import type { ResponsiveImageView } from "@slfinrtl/ui-bff-routes"

export const pictureStaticSizes = [160, 240, 320, 640, 960, 1280, 1600] as const
export type PictureStaticSize = (typeof pictureStaticSizes)[number]

export const getRelevantImageVariants = (
	picture: ResponsiveImageView | undefined,
	size: PictureStaticSize,
): { avif: string | undefined; jpeg: string | undefined; webp: string | undefined } | undefined => {
	if (picture) {
		const { variants } = picture
		return {
			avif:
				variants.find((img) => img.mimeType === "image/avif" && img.width === size)?.url ??
				variants.find((img) => img.mimeType === "image/avif")?.url,
			jpeg:
				variants.find((img) => img.mimeType === "image/jpeg" && img.width === size)?.url ??
				variants.find((img) => img.mimeType === "image/jpeg")?.url,
			webp:
				variants.find((img) => img.mimeType === "image/webp" && img.width === size)?.url ??
				variants.find((img) => img.mimeType === "image/webp")?.url,
		}
	}
	return undefined
}
